import moment from 'moment';

export class DateUtils {
  static timeAgo(date: string): string {
    const now = moment();
    const created = moment(date);

    const diffSeconds = now.diff(created, 'seconds');
    const diffMinutes = now.diff(created, 'minutes');
    const diffHours = now.diff(created, 'hours');
    const diffDays = now.diff(created, 'days');
    const diffWeeks = now.diff(created, 'weeks');
    const diffMonths = now.diff(created, 'months');
    const diffYears = now.diff(created, 'years');

    if (diffSeconds < 60) {
      return 'just now';
    }
    if (diffMinutes < 60) {
      return `${diffMinutes}m`;
    }
    if (diffHours < 24) {
      return `${diffHours}h`;
    }
    if (diffDays < 7) {
      return `${diffDays}d`;
    }
    if (diffWeeks < 4) {
      return `${diffWeeks}w`;
    }
    if (diffMonths < 12) {
      return `${diffMonths}mo`;
    }

    return `${diffYears}y`;
  }

  static timeRemaining(endDate?: string): string | null {
    if (!endDate) {
      return null;
    }

    const now = moment();
    const date = moment(endDate);
    if (!date.isValid()) {
      return null;
    }

    const duration = moment.duration(date.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = Math.floor(duration.asHours()) % 24;
    const minutes = Math.floor(duration.asMinutes()) % 60;
    const seconds = Math.floor(duration.asSeconds()) % 60;

    const formatUnit = (value: number, unit: string): string =>
      `${value} ${unit}${value !== 1 ? 's' : ''}`;

    if (days > 0) {
      return `${formatUnit(days, 'day')}, ${formatUnit(hours, 'hour')}, ${formatUnit(minutes, 'minute')} left`;
    } else if (hours > 0 || minutes > 0 || seconds > 0) {
      return `${formatUnit(hours, 'hour')}, ${formatUnit(minutes, 'minute')}, ${formatUnit(seconds, 'second')} left`;
    } else {
      return `${formatUnit(0, 'hour')}, ${formatUnit(0, 'minute')}, ${formatUnit(0, 'second')} left`;
    }
  }
}
